<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',

  created() {
      
  },
  methods: {
 
  }
}
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  margin: 0 auto;
}

.el-carousel__indicator--horizontal .el-carousel__button {
    width: 10px;
    height: 10px;
    background: transparent;
    border-radius: 50%;
    opacity: 0.5;
}  
.el-carousel__indicator--horizontal.is-active .el-carousel__button{
    width: 5px;
    height: 5px;
    background: red;
    border-radius: 50%;
    opacity: 1;
}

/* 解决el表格边框层级过高影响视图问题 */
.el-table--border, .el-table--group{
  z-index: 0;
}

.el-table--border::after, .el-table--group::after{
  z-index: 0;
}

.el-picker-panel__body-wrapper {
  width: 95%;
}

.el-picker-panel__sidebar {
  width: 60px;
  padding: 5px;
  margin-left: 50px;
}

body .el-table th.gutter{
  display: table-cell!important;
}


/* 优化超链接样式，去掉下划线去掉字体颜色变化 */
a {    
    text-decoration:none;
    color: black;
}


</style>



// WEBPACK FOOTER //
// src/App.vue